export const milestoneTableColumns = [
  {
    label: "任务标题",
    prop: "name",
    width: "180",
    contentAlign: "left"
  },
  {
    label: "状态",
    prop: "status",
    width: "80",
    contentAlign: "center"
  },
  {
    label: "负责人",
    prop: "assigneeUser.name",
    width: "80",
    contentAlign: "center"
  },
  {
    label: "计划完成时间",
    prop: "dueDate",
    width: "100",
    contentAlign: "center"
  },
  {
    label: "实际完成时间",
    prop: "completeAt",
    width: "100",
    contentAlign: "center"
  },
  {
    label: "计划周期",
    prop: "dueDateStr",
    width: "80",
    contentAlign: "center"
  },
  {
    label: "实际周期",
    prop: "completeAtStr",
    width: "80",
    contentAlign: "center"
  },
  {
    label: "备注",
    prop: "description",
    width: "150",
    contentAlign: "center"
  }
]

export const milestoneHistoryTableColumns = [
  {
    label: "版本号",
    value: "versionCode"
  },
  {
    label: "状态",
    value: "status"
  },
  {
    label: "更新内容",
    value: "upContent"
  },
  {
    label: "创建人",
    value: "creatorUser.name"
  },
  {
    label: "创建时间",
    value: "creatAt"
  }
]

export const riskTableColumns = [
  {
    label: "任务标题",
    value: "name",
    contentAlign: "left",
    width: "180"
  },
  {
    label: "状态",
    value: "status",
    contentAlign: "center",
    width: "80"
  },
  {
    label: "负责人",
    value: "assigneeUser.name",
    contentAlign: "center",
    width: "80"
  },
  {
    label: "截止时间",
    value: "dueDate",
    contentAlign: "center",
    width: "100"
  },
  {
    label: "风险等级",
    value: "riskLevel",
    contentAlign: "center",
    width: "80"
  },
  {
    label: "应对方案",
    value: "planDetail",
    contentAlign: "center",
    width: "150"
  },
  {
    label: "完成时间",
    value: "completeAt",
    contentAlign: "center",
    width: "100"
  },
  {
    label: "备注",
    value: "description",
    contentAlign: "center",
    width: "120"
  }
]
